module.exports = __webpack_public_path__ + "images/icons_v2/location-map-premier-98a6edc5.svg";